import store from "../store/index";

const leastPrivilege = [ 
                            'microphone', 'camera', 'fodeviceselection', 
                            'hangup',  'settings', 'videoquality', 'filmstrip', 
                            'feedback', 'stats', 'shortcuts', 'select-background'
                        ];

const userNamesHiddenPrivilege = leastPrivilege.concat(
                            [ 
                                'desktop', 'shareaudio', 'sharedvideo', 'whiteboard' 
                            ]);

const defaultPrivilege = userNamesHiddenPrivilege.concat(
                            [
                                'participants-pane', 'chat', 'raisehand', 'mute-everyone'
                            ]);

const adminPrivilege =  defaultPrivilege.concat(
                            [ 
                                'recording', 'livestreaming'
                            ]);

const isUserFromAllowedDomain = (email, allowedDomains) => {
    if (!email || email.trim() === "" || !allowedDomains || allowedDomains.length === 0) {
        return false;
    }
    var validDomain = false;
    for(let index = 0; index < allowedDomains.length; index++) {
        if (email.trim().endsWith("@" + allowedDomains[index].trim())) {
            validDomain = true;
            break;
        }
    }
    return validDomain;
}

const isUserAnonymous = (loggedIn, email, loginDomainsEnabled, allowedDomains) => {
    if (loginDomainsEnabled) {
        const userIsFromAllowedDomain = isUserFromAllowedDomain(email, allowedDomains);
        return !userIsFromAllowedDomain;
    }
    return !loggedIn;
};

const getToolbarButtons = (canRecordVideo) => {
    const restrictControlsForAnonymousUsers = store.state.mainRoomConfig.currentRoom.restrictControlsForAnonymousUsers;
    const hideUserNames = store.state.mainRoomConfig.currentRoom.hideUserNames;
    const loggedIn = store.state.user.profile.loggedIn;
    const email = store.state.user.profile.email;
    const loginDomainsEnabled = store.state.mainRoomConfig.currentRoom.enableLoginDomains;
    const allowedDomains = store.state.mainRoomConfig.currentRoom.allowedLoginDomains;
    const isAnonymousUser = isUserAnonymous(loggedIn, email, loginDomainsEnabled, allowedDomains);
    if (isAnonymousUser && restrictControlsForAnonymousUsers) {
        return leastPrivilege;
    }
    if (hideUserNames) {
        return userNamesHiddenPrivilege;
    }
    if (loggedIn && canRecordVideo) {
        return adminPrivilege;
    }
    return defaultPrivilege;
}

export {
    getToolbarButtons
}
